"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginateListEditorDocuments = void 0;
const Apiv2Client_1 = require("../Apiv2Client");
const ListEditorDocumentsCommand_1 = require("../commands/ListEditorDocumentsCommand");
const core_1 = require("@smithy/core");
exports.paginateListEditorDocuments = (0, core_1.createPaginator)(Apiv2Client_1.Apiv2Client, ListEditorDocumentsCommand_1.ListEditorDocumentsCommand, "nextToken", "nextToken", "pageSize");
